module.exports = __webpack_public_path__ + "img/software_img5.4bd96b37.png";